<template>
  <a-auto-complete
    :value="value"
    :style="{ width: '100%' }"
    :options="searchOptions"
    placeholder="Поиск по названию"
    :filter-option="fuzzyMatchOption"
    @update:value="onUpdateValue"
    @select="onSelect" />
</template>

<script setup>
import { computed } from 'vue';
import { fuzzyMatchOption } from '@/helpers/fuzzyMatchOption';

const props = defineProps({
  searchList: {
    default: () => [],
    type: Array,
  },
  value: {
    default: '',
    type: String,
  },
  labelFormatter: {
    default: null,
    type: Function,
  },
});

const emit = defineEmits(['update:value', 'select']);

const searchOptions = computed(() => props.searchList.map((item) => {
  const label = props.labelFormatter ? props.labelFormatter(item) : item.name;
  return {
    value: label,
    label,
    rawValue: item.name,
  };
}));

const onUpdateValue = (newValue) => {
  emit('update:value', newValue);
};

const onSelect = (selectedValue, option) => {
  emit('select', option?.rawValue || selectedValue, option);
};
</script>
